module.exports = __webpack_public_path__ + "static/media/magpieBanner.f8ac77ee.png";